import { render, staticRenderFns } from "./Origins.vue?vue&type=template&id=e137ed1c&scoped=true&"
import script from "./Origins.vue?vue&type=script&lang=js&"
export * from "./Origins.vue?vue&type=script&lang=js&"
import style0 from "./Origins.vue?vue&type=style&index=0&id=e137ed1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e137ed1c",
  null
  
)

export default component.exports